export function hardRedirectTo(url: string) {
  if (typeof window !== 'undefined') {
    window.location.assign(url);
  }
}
